import { DatePicker, DatePickerProps } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import React from 'react';
import { IField } from '@hooks/useField';

export type CompetenciaFieldProps = Omit<DatePickerProps, "value" | "onChange"> & {
    field: IField,
    updateFieldStateOnChange?: boolean
    onValueChanged?: (value: any) => void
    onEnter?: React.KeyboardEventHandler<HTMLDivElement> | undefined
}

export function CompetenciaField ({
    field, 
    name,
    onValueChanged, 
    helperText, 
    updateFieldStateOnChange, 
    onEnter,
    onKeyDown,
    ...props
}: CompetenciaFieldProps) {
    const competenciaToDate = React.useCallback((competencia?: string) : MaterialUiPickersDate => {
        if (competencia !== undefined && competencia.length === 4) {
            const year = parseInt(`20${competencia.substr(0, 2)}`);
            const month = parseInt(competencia.substr(2));

            return new Date(year, month - 1, 1);
        }

        return null;
    }, []);

    const dateToCompetencia = React.useCallback((date?: MaterialUiPickersDate) : string | undefined => {
        if (date !== undefined && date !== null && date.getDate) {
            const year = date.getFullYear().toString().substr(2);
            const month = (date.getMonth() + 1).toString().padStart(2, "0");

            return `${year}${month}`;
        }

        return undefined;
    }, []);

    const [_value, _setValue] = React.useState<MaterialUiPickersDate>(competenciaToDate(field.value));

    const handleChange = React.useCallback((date: MaterialUiPickersDate) => {
        if (date !== _value) {
            _setValue(date);
        }
    }, [_value]);

    const handleKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter" && onEnter !== undefined) {
            onEnter(e);
        }

        if (onKeyDown !== undefined) {
            onKeyDown(e);
        }
    }, [onEnter, onKeyDown]);

    //Reage à mudança do valor interno
    //Set o valor na ref
    //Chama o evento o change externo
    //Verifica se é para subir o estado automaticamente através da propriedade updateFieldStateOnChange
    React.useEffect(() => {
        const competenciaValue = dateToCompetencia(_value);

        field.setInputValue(competenciaValue);

        if (onValueChanged !== undefined) {
            onValueChanged(competenciaValue);
        }

        if (updateFieldStateOnChange === true && field.value !== competenciaValue) {
            field.setValue(competenciaValue);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_value, onValueChanged, updateFieldStateOnChange]);

    //Reage à mudança do valor externo
    //Atualiza o valor interno pelo valor externo
    React.useEffect(() => {
        const competenciaValue = dateToCompetencia(_value);

        if (field.value !== competenciaValue) {
            _setValue(competenciaToDate(field.value));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.value]);

    React.useEffect(() => {
        if (field.transition === "reset") {
            _setValue(competenciaToDate(field.initialValueRef?.current));
            field.clearTransition();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.transition]);

    return (
        <DatePicker 
            name={field !== undefined ? field.name : name}
            variant="inline"
            format="MMMM/yyyy"
            autoOk
            {...props}    
            views={['year', 'month']}
            helperText={!!field.error ? field.error : helperText}
            error={!!field.error}
            value={_value || null}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            fullWidth
        />
    )
}